
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0C4.039 0 0 4.039 0 9s4.039 9 9 9 9-4.039 9-9-4.039-9-9-9zm0 1.688c4.049 0 7.313 3.263 7.313 7.312S13.049 16.313 9 16.313A7.3 7.3 0 011.687 9 7.3 7.3 0 019 1.687z","font-family":"sans-serif","overflow":"visible"}}),_c('path',{attrs:{"d":"M7.912 10.553c0-.615.076-1.105.225-1.47.149-.364.42-.722.817-1.074.4-.356.666-.644.798-.863.131-.225.198-.46.198-.705 0-.743-.344-1.114-1.029-1.114-.326 0-.587.101-.785.302-.192.198-.294.473-.304.824H5.923c.008-.84.28-1.496.81-1.971.537-.474 1.266-.711 2.19-.711.93 0 1.653.225 2.167.678.516.45.772 1.084.772 1.905 0 .373-.083.728-.25 1.062-.167.33-.46.696-.877 1.1l-.535.508a1.824 1.824 0 00-.573 1.127l-.026.403zm-.191 2.024a.96.96 0 01.297-.725 1.071 1.071 0 01.772-.29c.311 0 .566.096.765.29a.952.952 0 01.302.725c0 .29-.099.53-.297.718-.193.19-.45.284-.77.284-.322 0-.58-.095-.779-.284a.962.962 0 01-.29-.717z"}})])
          )
        }
      }
    